import Actions from "../action";

const initialState = {
    isLoading: false,
    isCamerasLoading: false,
    isRequesting: false,
    alignmentList: [],
    totalCount: 0,
    cameras: [],
    cooldownMinutes: 15,
    error: false,
};

const CameraAlignmentReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case Actions.CAMERA_ALIGNMENT_LIST: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case Actions.CAMERA_ALIGNMENT_LIST_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                alignmentList: action.data?.results || [],
                totalCount: action.data?.count ?? 0,
                error: false,
            };
        }
        case Actions.CAMERA_ALIGNMENT_LIST_FAILURE: {
            return {
                ...state,
                isLoading: false,
                alignmentList: [],
                totalCount: 0,
                error: action.error,
            };
        }
        case Actions.CAMERA_ALIGNMENT_CAMERAS: {
            return {
                ...state,
                isCamerasLoading: true,
            };
        }
        case Actions.CAMERA_ALIGNMENT_CAMERAS_SUCCESS: {
            const body = action.data?.response || action.data || {};
            return {
                ...state,
                isCamerasLoading: false,
                cameras: body.cameras || [],
                cooldownMinutes: body.cooldown_minutes ?? state.cooldownMinutes,
                error: false,
            };
        }
        case Actions.CAMERA_ALIGNMENT_CAMERAS_FAILURE: {
            return {
                ...state,
                isCamerasLoading: false,
                cameras: [],
                error: action.error,
            };
        }
        case Actions.CAMERA_ALIGNMENT_REQUEST: {
            return {
                ...state,
                isRequesting: true,
            };
        }
        case Actions.CAMERA_ALIGNMENT_REQUEST_SUCCESS:
        case Actions.CAMERA_ALIGNMENT_REQUEST_FAILURE: {
            return {
                ...state,
                isRequesting: false,
            };
        }
        default:
            return state;
    }
};

export default CameraAlignmentReducer;

export const getCameraAlignmentListSelector = (state) =>
    state?.CAMERA_ALIGNMENT?.alignmentList || [];
export const getCameraAlignmentTotalCountSelector = (state) =>
    state?.CAMERA_ALIGNMENT?.totalCount ?? 0;
export const getCameraAlignmentLoadingSelector = (state) =>
    state?.CAMERA_ALIGNMENT?.isLoading || false;
export const getCameraAlignmentCamerasSelector = (state) =>
    state?.CAMERA_ALIGNMENT?.cameras || [];
export const getCameraAlignmentCamerasLoadingSelector = (state) =>
    state?.CAMERA_ALIGNMENT?.isCamerasLoading || false;
export const getCameraAlignmentRequestingSelector = (state) =>
    state?.CAMERA_ALIGNMENT?.isRequesting || false;
export const getCameraAlignmentCooldownSelector = (state) =>
    state?.CAMERA_ALIGNMENT?.cooldownMinutes ?? 15;
